import React from 'react';
import { Link } from 'react-router-dom';
import GuideTypeBadge from './GuideTypeBadge';

function GuideCard({ article }) {
  return (
    <Link
      to={`/learn/${article.slug}`}
      className="p-5 bg-white rounded-lg shadow border border-gray-100 hover:border-blue-200 transition flex flex-col h-full"
    >
      <GuideTypeBadge guideType={article.guideType} readMinutes={article.readMinutes} />
      <h3 className="font-semibold text-gray-900">{article.title}</h3>
      <p className="text-sm text-gray-600 mt-2 line-clamp-3 flex-1">{article.description}</p>
    </Link>
  );
}

export default GuideCard;
